import classnames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import Container from './container'
import Content from './content'
import Header from './header'
import styles from './layout.module.scss'

const Layout = ({ children, className }) => {
  if (children === null) {
    return null
  }

  return <div className={classnames(className, styles.layout)}>{children}</div>
}

Layout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string
}

Layout.defaultProps = {
  children: null,
  className: null
}

Layout.Container = Container
Layout.Header = Header
Layout.Content = Content

export default Layout
